import { Box } from '@mui/material';
import PageMeta from 'src/components/app/PageMeta';
import { Suspense, lazy } from 'react';
import LoadingProgress from 'src/components/app/LoadingProgress';

const NewPricing = lazy(() => import('./upgrade/NewPricing'));

const Upgrade = () => (
  <>
    <PageMeta title="Upgrade your plan" />
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: {
            xs: 1,
            md: 2
        },
      }}
    >
      <Box sx={{ mt: 5, mx: {
          xs: 1,
          ms: 1,
          md: 5
      } }}>
        <Suspense fallback={<LoadingProgress open />}>
          <NewPricing
            cancelURL="/app/upgrade?canceled=true&session_id={CHECKOUT_SESSION_ID}"
            successURL="/app/payment-success?session_id={CHECKOUT_SESSION_ID}"
            redirect={false}
          />
        </Suspense>
      </Box>
    </Box>
  </>
);

export default Upgrade;
